import { gql } from '@apollo/client';

export const CYCLE_COUNT_FIELDS = gql`
    fragment CycleCountFields on cycle_counts {
        cycle_count_id
        warehouse_id
        client_id
        assigned_teammate_id
        template_id
        status
        date
        started_at
        completed_at
        created_at
        last_modified_at
    }
`;

export const CYCLE_COUNT_LOCATION_FIELDS = gql`
    fragment CycleCountLocationFields on cycle_count_locations {
        cycle_count_location_id
        cycle_count_id
        warehouse_location
        audited_at
    }
`;

export const CYCLE_COUNT_SHIPPER_FIELDS = gql`
    fragment CycleCountShipperFields on cycle_count_shippers {
        cycle_count_id
        shipper_id
    }
`;

export const CYCLE_COUNT_TEMPLATE_FIELDS = gql`
    fragment CycleCountTemplateFields on cycle_count_templates {
        cycle_count_template_id
        warehouse_id
        client_id
        name
        warehouse_locations
        created_at
    }
`;
